import { Row } from "antd";
import { useCallback, useMemo, useState } from "react";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { Accounts } from ".";
import { ISelectedConversation } from "../../../../types/SelectedConversation";

type ClosedAccountsProps = {
  data: any[];
  conversation: ISelectedConversation | null;
  readConversation: (
    contractNumber: number,
    selectedConvValues: ISelectedConversation
  ) => void;
};

export const ClosedAccounts = ({
  data,
  conversation,
  readConversation,
}: ClosedAccountsProps) => {
  const [collapsed, setCollapsed] = useState<boolean>(true);

  const containerClass: string = useMemo(
    () => `w-100 closed-items ${collapsed ? "mb-2" : ""}`,
    [collapsed]
  );

  const toggle = useCallback(() => {
    setCollapsed((prev: boolean) => !prev);
  }, []);

  return (
    <Row className={containerClass}>
      {data.length > 0 && (
        <Row className="d-block w-100">
          <Row
            className="w-100 pa-4 alisgn center logo-cursor closed-acc"
            onClick={toggle}
          >
            {collapsed ? <RightOutlined /> : <DownOutlined />}
            <span className="ml-2 text-md w-500">Closed Accounts Chats</span>
          </Row>

          {!collapsed && (
            <Row className="w-100 mt-4">
              <Accounts
                data={data}
                conversation={conversation}
                readConversation={readConversation}
              />
            </Row>
          )}
        </Row>
      )}
    </Row>
  );
};
